module.exports = __webpack_public_path__ + "static/media/info-24px.6adbd227.svg";